import { _ as r } from "./index918.mjs";
import { _ as o } from "./index837.mjs";
var t = r, a = o, e = t(a, "Promise"), s = e;
export {
  s as _
};
